module.exports = __webpack_public_path__ + "img/U2B50.fdd26ad2.png";